import { Component } from 'react';
import { throttle, uniq } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import config from '../../../config/config';
import { isUsingMocks } from '../../../utils/utils';
import { PRODUCT_TYPE_ENUM_MAP } from '../../../settings/settings';
import { SSJBeaconButton } from '../Beacon/Registry';
import { BeaconModal } from '@trp-ii-ii-component-library/ii-components';

import './SessionTimer.scss';

export class SessionTimer extends Component {
  autoLogout() {
    const {
      userProductTypes: { entity },
    } = this.props;
    const {
      hasAPP,
      hasBrokerage,
      hasMutualFund,
      hasNAT529,
      hasMD529,
      hasAK529,
    } = entity;
    const accounts = [];
    if (hasMutualFund) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MUTUAL_FUND'] });
    }
    if (hasAK529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['ALASKA_529'] });
    }
    if (hasNAT529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['NATIONAL_529'] });
    }
    if (hasMD529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MARYLAND_529'] });
    }
    if (hasBrokerage) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['BROKERAGE'] });
    }
    if (hasAPP) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MANAGED_ACCOUNT'] });
    }
    const products = uniq(accounts.map((a) => a.productType));
    this.hideSessionRefreshModal();
    window.location.href = `${config.url}/usis/login/logout?sdurl=https://www.troweprice.com/usis/my-accounts/post-logout?productTypes=${products}`;
  }

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTimerId: null,
    };

    this.restartSessionTimer = throttle(
      this.restartSessionTimer.bind(this),
      5000
    );
    this.autoLogout = this.autoLogout.bind(this);
  }

  componentDidMount() {
    if (isUsingMocks()) {
      return;
    }

    this.restartSessionTimer.bind(this);
    const body = document.getElementsByTagName('body')[0];
    body.addEventListener(
      'mousemove',
      this.restartSessionTimer.bind(this),
      true
    );
    body.addEventListener(
      'keypress',
      this.restartSessionTimer.bind(this),
      true
    );
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.removeEventListener('mousemove', this.restartSessionTimer.bind(this));
    body.removeEventListener('keypress', this.restartSessionTimer.bind(this));
  }

  restartSessionTimer() {
    const logoutMilliseconds = 1500000;
    const modalMilliseconds = 780000;

    if (this.sessionTimerId) {
      clearTimeout(this.sessionTimerId);
    }

    const { modalTimerId } = this.state;
    if (modalTimerId) {
      clearTimeout(modalTimerId);
    }
    const newModalTimerId = setTimeout(() => {
      this.showSessionRefreshModal();
    }, modalMilliseconds);
    this.setState({ modalTimerId: newModalTimerId });

    this.sessionTimerId = setTimeout(this.autoLogout, logoutMilliseconds);
  }

  showSessionRefreshModal = () => {
    this.setState({ showModal: true });
  };

  hideSessionRefreshModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { showModal } = this.state;
    return (
      <BeaconModal
        open={showModal}
        width={800}
        title={'Session Timeout'}
        onClose={() => this.hideSessionRefreshModal()}
      >
        <p>
          You're being timed out due to inactivity. Please choose to stay signed
          in or log out. Otherwise, you will be logged off automatically
        </p>
        <div className="action-zone-align-right" slot="action-zone">
          <SSJBeaconButton
            id="logoutButton"
            type="button"
            variant="tertiary"
            scale="jumbo"
            onClick={() => this.autoLogout()}
            label="Log Out"
          />
          <SSJBeaconButton
            id="restartButton"
            type="button"
            variant="primary"
            scale="normal"
            onClick={() => this.hideSessionRefreshModal()}
            label="Stay Logged In"
          />
        </div>
      </BeaconModal>
    );
  }
}

const mapStateToProps = (state) => {
  const { userProductTypes } = state;
  return { userProductTypes };
};

export default compose(connect(mapStateToProps))(SessionTimer);
